module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7sClK"))).then(() => parcelRequire('d0iPb'));